package one.healthium.uscreen.ui.util

import androidx.compose.foundation.layout.padding
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.uscreen.domain.models.UScreenPadding

fun Modifier.uscreenPadding(
    padding: UScreenPadding?,
    defaultHorizontal: Int = 24,
): Modifier {
    if (padding == null) return this.padding(horizontal = defaultHorizontal.dp)

    val left = padding.left ?: padding.horizontal ?: defaultHorizontal
    val right = padding.right ?: padding.horizontal ?: defaultHorizontal
    val top = padding.top ?: padding.vertical ?: 0
    val bottom = padding.bottom ?: padding.vertical ?: 0

    return this.padding(start = left.dp, end = right.dp, top = top.dp, bottom = bottom.dp)
}
